import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  highestScore: {
    color: '#189A34',
    paddingLeft: '5px'
  },
  scoreWithConflict: {
    color: '#FF7A00',
    paddingLeft: '5px'
  }
});